<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="スカウト＿テンプレート設定"
      />
      <div class="grid-x align-justify">
        <div class="medium-9 cell">
          <p>スカウト作成画面で使用するテンプレートを設定します。</p>
        </div>
        <div class="medium-3 cell">
          <button
            class="float-right boss-button boss-button-new"
            @click="$router.push({ name: 'settingScoutTemplateRegister' })"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">新規作成する</span>
          </button>
        </div>
      </div>
      <table
        v-if="templates.length"
        class="unstriped hover boss-table"
      >
        <thead>
          <tr>
            <th class="boss-table-head-center">
              テンプレート名
            </th>
            <th class="boss-table-head-center">
              スカウト特典
            </th>
            <th class="boss-table-head-center boss-update">
              最終更新者
            </th>
            <th class="boss-table-head-center boss-operation">
              編集
            </th>
            <th class="boss-table-head-center boss-copy">
              コピー
            </th>
            <th class="boss-table-head-center boss-operation">
              削除
            </th>
            <th class="boss-table-head-center boss-display-change">
              <div class="pega-setting-templates-relative">
                テンプレートへの表示/非表示
                <span
                  v-tooltip="{ content: '非表示にすると「テンプレート」に反映されません'}"
                  class="pega-circle small-right-top"
                >?</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in templates"
            :key="item.id"
            data-test="template-item"
          >
            <td
              :data-test="'template-name-' + item.id"
              class="boss-table-data"
            >
              {{ item.name }}
            </td>
            <td
              class="boss-table-data"
            >
              <span
                v-for="(favor, i) in item.specialFavors"
                :key="i"
                v-tooltip="{ content: specialFavorBy(favor.id).description}"
                :data-test="'special-favor-' + item.id + '-' + favor.id"
                class="boss-bonus-check-text boss-check-true"
              >{{ favor.name }}</span>
            </td>
            <td
              :data-test="'modified-' + item.id"
              class="boss-table-data"
            >
              {{ item.modified }}
            </td>
            <td class="boss-table-data">
              <button
                class="boss-icon-pencil"
                data-test="template-edit"
                @click="$router.push({ name: 'settingScoutTemplateEdit', params: { id: item.id }})"
              />
            </td>
            <td class="boss-table-data">
              <div
                data-test="template-copy"
                @click="doCopy(item.id)"
              >
                <span class="boss-icon boss-icon-copy-regular boss-icon-copy" />
              </div>
            </td>
            <td class="boss-table-data">
              <button
                class="boss-icon-trash"
                data-test="template-remove"
                @click="doRemove(item.id)"
              />
            </td>
            <td class="boss-table-data">
              <div class="switch toggle-switch">
                <input
                  :id="`toggle-${item.id}`"
                  :data-test="`toggle-${item.id}`"
                  class="toggle-input"
                  type="checkbox"
                  :checked="item.isDisplayed"
                  @change="changeDisplay(item.id, item.isDisplayed)"
                >
                <label
                  :for="`toggle-${item.id}`"
                  class="toggle-label"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-else
        class="grid-x grid-margin-y align-center margin-top-2"
      >
        <span class="cell medium-4 subheader">テンプレートが作成されていません。</span>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import { mapGetters } from 'vuex'
import Indicator from '@/lib/indicator'
export default {
  components: {
    SettingHeader
  },
  data () {
    return {
      templates: []
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    })
  },
  created () {
    this.fetchScoutTemplates()
      .then(response => this.$set(this, 'templates', response.data))
  },
  methods: {
    fetchScoutTemplates () {
      return this.$http.secured.get('/company/scout/message/templates')
    },
    removeTemplate (id) {
      return this.$http.secured.delete(`/company/scout/message/templates/${id}`)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
        .then(() => {
          this.removeTemplate(id)
            .then(() => {
              Indicator.emitShow()
              this.$toasted.global.success({ message: 'テンプレートを削除しました' })
              this.fetchScoutTemplates()
                .then(response => this.$set(this, 'templates', response.data))
                .finally(() => {
                  Indicator.emitHide()
                })
            })
        })
        .catch(() => {})
    },
    doCopy (id) {
      this.$http.secured.post(`/company/scout/message/templates/${id}/_copy`).then(() => {
        this.$toasted.global.success({ message: 'テンプレートをコピーしました' })
        this.fetchScoutTemplates().then(response => this.$set(this, 'templates', response.data))
      })
    },
    changeDisplay (id, isDisplayed) {
      this.$http.secured.put(`/company/scout/message/templates/${id}/display`, {
        isDisplayed: !isDisplayed
      }).then(response => {
        this.$set(this.templates, this.templates.findIndex((template) => template.id === response.data.id), response.data)
      })
    }
  }
}
</script>
